<template>
  <div id="app">

    <headBar></headBar>
    <banner></banner>
    <limitScroll v-if="stepForm == 0"></limitScroll>
    <loader v-show="isLoading"></loader>
    <step1 v-if="stepForm == 1"></step1>
    <step2 v-if="stepForm == 2"></step2>
    <step3 v-if="stepForm == 3 && !isLoading"></step3>
    <sms v-if="stepForm == 4"></sms>
    <thanks v-if="stepForm == 5"></thanks>
    <invalidAddress v-if="stepForm == 6"></invalidAddress>
    <steps></steps>
    <aboutUs></aboutUs>
    <aboutUs2></aboutUs2>
    <slider></slider>
    <footerComponents></footerComponents>
    


  </div>
</template>

<script>
 import {mapState} from 'vuex'

export default {
  name: 'app',
  components: {
    headBar:()=>import('@/components/headBar'),
    banner:()=>import('@/components/banner'),
    limitScroll:()=>import('@/components/limitScroll'),
    steps:()=>import('@/components/steps'),
    aboutUs:()=>import('@/components/aboutUs'),
    aboutUs2:()=>import('@/components/aboutUs2'),
    slider:()=>import('@/components/slider'),
    footerComponents:()=>import('@/components/footer'),
    step1:()=>import('@/components/step1'),
    step2:()=>import('@/components/step2'),
    step3:()=>import('@/components/step3'),
    sms:()=>import('@/components/sms'),
    thanks:()=>import('@/components/thanks'),
    invalidAddress:()=>import('@/components/invalidAddress'),
    loader:()=>import('@/components/loader'),
 

  },
  computed:{
    ...mapState({
      stepForm: state => state.alfaForm.stepForm,
      isLoading: state => state.isLoading
    }),

  },
  mounted(){

    this.$store.dispatch('updateAlfaFormValue',{
      formKey:'AlfaCard_FormSaved',
      parent:'',
      value:{
          newGUUID: "61941344-872A-4F85-B7F9-6D445475F1FC",
          DemNu: 1977,
          dateSave: "2021-06-22T10:00:45.997",
          ConfirmationGUID:'BB971CE6-6B67-4CB1-B6A5-97E1D1490B6A'
      }
    });
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Roboto+Slab:wght@100;400;1000&display=swap');

html{font-family: 'Roboto Slab', serif;}
html, body, p,ul, li,input,button, h1, h2, h3{margin: 0;padding: 0;}
li{list-style: none;}
h2{font-size: 5.6vw;}
p{ font-size: 4.2vw;}
img, svg{border:0;display: inline-block;}


 /* форма: */
button {font-size: 4.1vw; width: 48vw;height: 11vw;color: #fff;border-radius: 3.1vw;;background-color: #5F2EEA;border-width: 0;}
input {font-size: 4.1vw; background-color: #F5F6FC; border: 1vw solid #5F2EEA;border-radius: 1.8vw; padding:3vw 5vw;}
.step{display: flex; justify-content: center;}
.stepWrap{font-size: 4.6vw;border: 0.6vw solid rgba(103, 103, 103, 0.28);border-radius: 100%; padding: 2.2vw 4.8vw;color: rgba(103, 103, 103, 0.28);}
.formaWrap{top: -110vw; position: relative; text-align: center;border: 1.8vw solid #F5F6FC;border-radius: 27px;padding-bottom: 10vw; width: 94%;height: 130vw;margin-right: auto;margin-left: auto;}
.nextstep{width: 1.6vw;height: 13vw;margin-right: 4vw;margin-left: 4vw;}
li input{ margin-bottom: 4vw;}
.d23 { height: 110vw;width: 97%;margin-left: auto;margin-right: auto;background: #F5F6FC;position: relative;transform: rotate(180deg);border-bottom-left-radius: 20px 20px;border-bottom-right-radius: 20px 20px;}
.d23:before {content: "";height: 0; width: 0;position: absolute; left: 0; top: -6vw;border-bottom: 6vw solid #F5F6FC;border-left: 48vw solid transparent;border-right: 48vw solid transparent;}
.current{border: 0.7vw solid #5F2EEA; color:#5F2EEA;}
.fillContact{padding-top: 6vw;padding-bottom: 6vw;}
form{padding-bottom: 8vw;}
.stepUp{margin-top: -4vw;}

@media screen and (min-width: 1140px) {
.wrapper{width: 1100px; margin-left: auto; margin-right: auto;}

/* форма: */
.step{column-gap:25px;}
.stepWrap{font-size: 34px;padding: 15px 31px; border: 2px solid rgba(103, 103, 103, 0.28);}
.current{border: 2px solid #5F2EEA;}
.nextstep { width: 28px;height: 72px;}
button {font-size: 30px; width: 295px;height: 77px;color: #fff;border-radius: 10px;}
.fillContact{font-size: 25px;padding-top: 35px;padding-bottom: 35px;}
.d23:before {top: -32px;border-bottom: 32px solid #F5F6FC;border-left: 533px solid transparent; border-right: 533px solid transparent;}
.d23{width: 1065px; border-bottom-left-radius: 20px 20px;border-bottom-right-radius: 20px 20px; height: 467px;}
.formaWrap{top: -464px;padding-bottom: 10px;width: 1065px;height: 642px; border: 9px solid #F5F6FC;}
input{font-size: 23px;background-color: #F5F6FC;border: 3px solid #5F2EEA;border-radius: 9px;padding: 13px 28px;}
li input {margin-bottom: 68px;}
.nextstep{margin-right: 10px;margin-left: 10px;}
.stepUp{margin-top: -36px;}
}

</style>
